import dayjs from "dayjs";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};
interface ClientConfirm {
  name: string;
  collectFrom: string;
  deliverTo: string;
  services: { name: string; cost: string; status: null }[];
  comments: string;
  movingDate: { date: string; status: null };
  packingDate: { date: string; status: null };
  isAcceptLiabilityCover: boolean;
  liabilityCover: string;
  isTerm: boolean;
  isAccepted: boolean;
  isSubmitted: boolean;
  notes: string | null;
  vatIncluded: boolean;
  driverQty: number;
  porterQty: number;
  packerQty: number;
  contentsValue: number | null;
  volume: number | null;
  paymentMethod: string | null;
  insuranceAmount: number | null;
  insurancePercentage: number | null;
  insuranceType: string | null;
}

export const clientConfirm = {
  services: [],
  // movingDate: { date: "",time:"", status: 'awaiting' },
  // packingDate: { date: "",time:"", status: 'awaiting' },
  colectionVolume: null,
  collectionVolumeUnit: null,
  collectionAddresses: [
    {
      volume: null,
      volume_unit: null,
    },
  ],
  notes: null,
  vatIncluded: false,
  driverQty: 0,
  porterQty: 0,
  packerQty: 0,
  contentsValue: null,
  volume: null,
  paymentMethod: null,
  insuranceAmount: null,
  insurancePercentage: null,
  insuranceType: null,
  invoiceNumber: null,
  isDepositeRecieved: false,
  isDepositAmountExceeds: false,
  // quoteData
  materialPriceChargeable: false,
  materials: [],
  ancillaries: [],
  subcontractorCharges: [],
  generalInfo: [],
  quoteTotal: 0,
  costTotal: 0,
};

export const confirmationDetails = [
  {
    id: "details",
    label: "",
    type: "title",
    md: 4,
  },
  {
    id: "name",
    label: "Name",
    placeHolder: "",
    type: "labelWithValue",
    isRequired: true,

    md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "details",
    label: "",
    type: "title",
    md: 4,
  },
  {
    id: "collectFrom",
    label: "Collect from",
    placeHolder: "",
    type: "labelWithValue",
    isRequired: true,
    md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "details",
    label: "Details",
    type: "title",
    md: 4,
  },
  {
    id: "deliveryTo",
    label: "Deliver to",
    placeHolder: "",
    type: "labelWithValue",
    isRequired: true,
    md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const staffCategories = [
  { label: "Drivers", quantity: "driverQty" },
  { label: "Porters", quantity: "porterQty" },
  { label: "Packers", quantity: "packerQty" },
];

// Improved validation function
export const confirmationValidateForm = (
  formData: any,
  isFullPackAccept: any,
  isDoorToDoorAccept: any,
) => {
  let isError = false;
  const localError: any = {};

  // Validate services
  formData?.services.forEach((service: any, index: any) => {
    // Check if both status and cost are provided
    if (!service?.status && (!service?.cost || service?.cost !== 0)) {
      return; // Skip validation for empty service entries
    }
    // If status or cost is missing, flag an error
    if (!(service?.status && (service?.cost || service?.cost === 0))) {
      isError = true;
      if (!localError.services) {
        localError.services = {};
      }
      localError.services[index] = {
        status: !service?.status ? "Please select a status" : "",
        cost:
          !service?.cost || service?.cost !== 0 ? "Please provide a cost" : "",
      };
    }
    if (
      !(service?.startDate && service?.startTime && service?.jobStatus) &&
      service?.status === "accept"
    ) {
      isError = true;
      if (!localError.services) localError.services = {};
      const serviceErrorKey = getConfirmationServiceKey(service, index);
      localError.services[serviceErrorKey] = {
        startDate: !service?.startDate ? "Start date is required" : "",
        startTime: !service?.startTime ? "Start time is required" : "",
        jobStatus: !service?.jobStatus ? "Please select job status" : "",
      };
    }
  });

  // 🚩 Validate date confirmation services (startDate, startTime, jobStatus)
  // if (Array.isArray(formData?.services)) {
  //   formData.services.forEach((service: any, index: number) => {

  //   });
  // }

  // Validate other fields like movingDate, packingDate, etc.
  if (
    !isDoorToDoorAccept &&
    !(
      formData?.movingDate?.status &&
      formData?.movingDate?.date &&
      formData?.movingDate?.time
    )
  ) {
    isError = true;
    localError.movingDate = {
      date: "Moving date is required",
      time: "Moving time is required",
      status: "Moving status is required",
    };
    // localError.movingDate = { status: "Moving status is required" };
  }

  if (
    !isFullPackAccept &&
    !(
      formData?.packingDate?.status &&
      formData?.packingDate?.date &&
      formData?.packingDate?.time
    )
  ) {
    isError = true;
    localError.packingDate = {
      date: "Packing date is required",
      time: "Packing time is required",
      status: "Packing status is required",
    };
    // localError.packingDate = { status: "Packing status is required" };
  }

  // if (!formData?.isAccepted) {
  //   isError = true;
  //   localError.isAccepted = "Please accept the above details";
  // }
  // if (!formData?.isTerm) {
  //   isError = true;
  //   localError.isTerm = "Please accept the terms and conditions";
  // }

  // Check if liabilityCover is required
  // if (formData.isAcceptLiabilityCover === null && !formData.liabilityCover) {
  //   isError = true;
  //   localError.liabilityCover = "Liability cover is required";
  // }

  // if(!formData?.comments){
  //   isError = true;
  //   localError.comments = "Please enter comments";
  // }

  return { isError, localError };
};

export const getConfirmationServiceKey = (service: any, index: number) => {
  const serviceId = service?.serviceId || service?.id;
  if (serviceId) {
    return String(serviceId);
  }

  const normalizedName = String(service?.name || service?.type || "service")
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

  return normalizedName || `service-${index}`;
};

export const validateDateRange = (
  service: any,
  field: "startDate" | "endDate",
  value: string | null
) => {
  if (!service) return null;

  const startDateValue = service?.startDate;
  const endDateValue = field === "endDate" ? value : service?.endDate;

  if (!startDateValue || !endDateValue) return null;

  const parsedStartDate = dayjs(startDateValue);
  const parsedEndDate = dayjs(endDateValue);

  if (!parsedStartDate.isValid() || !parsedEndDate.isValid()) return null;

  if (field === "endDate") {
    if (parsedEndDate.isSame(parsedStartDate, "day") || parsedEndDate.isBefore(parsedStartDate, "day")) {
      return "End date must be after the start date";
    }
  }

  if (field === "startDate") {
    if (parsedStartDate.isSame(parsedEndDate, "day") || parsedStartDate.isAfter(parsedEndDate, "day")) {
      return "End date must be after the start date";
    }
  }

  return null;
};

export const confirmationClientValidateForm = (
  formData: any,
  isFullPackAccept: any,
  isDoorToDoorAccept: any,
  isTesterSection: boolean,
) => {
  let isError = false;
  const localError: any = {};

  // Validate services
  formData?.services.forEach((service: any, index: any) => {
    // Check if both status and cost are provided
    if (!service?.status && (!service?.cost || service?.cost !== 0)) {
      return; // Skip validation for empty service entries
    }
    // If status or cost is missing, flag an error
    if (!(service?.status && (service?.cost || service?.cost === 0))) {
      isError = true;
      if (!localError.services) {
        localError.services = {};
      }
      localError.services[index] = {
        status: !service?.status ? "Please select a status" : "",
        cost:
          !service?.cost || service?.cost !== 0 ? "Please provide a cost" : "",
      };
    }

    // 🧠 Conditional validation based on tester version
    const shouldValidateJobDetails = isTesterSection
      ? service?.status === "accept" &&
        ["Removal", "Full Pack"].includes(service?.name)
      : service?.status === "accept";

    if (shouldValidateJobDetails) {
      const serviceErrorKey = getConfirmationServiceKey(service, index);
      const serviceErrors: Record<string, string> = {};

      if (!service?.startDate) {
        serviceErrors.startDate = "Start date is required";
      }
      if (!service?.startTime) {
        serviceErrors.startTime = "Start time is required";
      }
      if (!service?.jobStatus) {
        serviceErrors.jobStatus = "Please select job status";
      }

      const dateRangeError = validateDateRange(service, "endDate", service?.endDate);
      if (dateRangeError) {
        serviceErrors.endDate = dateRangeError;
      }

      if (Object.keys(serviceErrors).length > 0) {
        isError = true;
        if (!localError.services) localError.services = {};
        localError.services[serviceErrorKey] = {
          ...(localError.services[serviceErrorKey] || {}),
          ...serviceErrors,
        };
      }
    }
  });

  return { isError, localError };
};
